import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgBlueCheck = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={10}
    height={8}
    viewBox='0 0 10 8'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='M3.47159 8C3.25972 8.00016 3.05653 7.91718 2.90706 7.76943L0.244171 5.14935C0.0364086 4.9521 -0.0470163 4.65989 0.0259608 4.38504C0.0989379 4.11019 0.31696 3.89547 0.596231 3.82341C0.875502 3.75135 1.17256 3.83316 1.37323 4.03739L3.42685 6.058L8.45757 0.282295C8.64216 0.0647453 8.93149 -0.0381886 9.2148 0.0128915C9.49811 0.0639716 9.73154 0.261156 9.82574 0.528971C9.91995 0.796785 9.86033 1.09376 9.66972 1.30622L4.07766 7.72542C3.93294 7.89134 3.72452 7.99045 3.50248 7.99895L3.47159 8Z' />
  </svg>
);
export default SvgBlueCheck;
